'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$002dProduct14 from "./scala.-Product14.js";
var $p;
/** @constructor */
function $c_T14(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14) {
  this.n8 = null;
  this.ne = null;
  this.nf = null;
  this.ng = null;
  this.nh = null;
  this.ni = null;
  this.nj = null;
  this.nk = null;
  this.nl = null;
  this.n9 = null;
  this.na = null;
  this.nb = null;
  this.nc = null;
  this.nd = null;
  this.n8 = _1;
  this.ne = _2;
  this.nf = _3;
  this.ng = _4;
  this.nh = _5;
  this.ni = _6;
  this.nj = _7;
  this.nk = _8;
  this.nl = _9;
  this.n9 = _10;
  this.na = _11;
  this.nb = _12;
  this.nc = _13;
  this.nd = _14;
}
export { $c_T14 as $c_T14 };
$p = $c_T14.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_T14;
/** @constructor */
function $h_T14() {
}
export { $h_T14 as $h_T14 };
$h_T14.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.n = (function() {
  return 14;
});
$p.g = (function(n) {
  return $j_scala$002e$002dProduct14.$f_s_Product14__productElement__I__O(this, n);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().av(this, 147759069, true);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_T14) && ((((((((((((($j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.n8, x$0.n8) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.ne, x$0.ne)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nf, x$0.nf)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.ng, x$0.ng)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nh, x$0.nh)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.ni, x$0.ni)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nj, x$0.nj)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nk, x$0.nk)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nl, x$0.nl)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.n9, x$0.n9)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.na, x$0.na)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nb, x$0.nb)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nc, x$0.nc)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nd, x$0.nd))));
});
$p.o = (function() {
  return "Tuple14";
});
$p.b = (function() {
  return (((((((((((((((((((((((((((("(" + this.n8) + ",") + this.ne) + ",") + this.nf) + ",") + this.ng) + ",") + this.nh) + ",") + this.ni) + ",") + this.nj) + ",") + this.nk) + ",") + this.nl) + ",") + this.n9) + ",") + this.na) + ",") + this.nb) + ",") + this.nc) + ",") + this.nd) + ")");
});
function $isArrayOf_T14(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eD)));
}
export { $isArrayOf_T14 as $isArrayOf_T14 };
var $d_T14 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_T14, "scala.Tuple14", ({
  eD: 1,
  b: 1,
  c: 1,
  rM: 1,
  a: 1
}));
export { $d_T14 as $d_T14 };
